import { ExternalCalendar } from '@griply/types';
import { QueryClient, useQuery, useQueryClient } from '@tanstack/react-query';
import { createContainedQueryFn } from 'shared/lib/@tanstack-query';
import { getExternalConnectionCalendars } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const queryKey = 'external-connection-calendars';

export const createExternalConnectionCalendarsQueryFn = (
  queryClient: QueryClient,
  externalConnectionId: ID,
) =>
  createContainedQueryFn<ExternalCalendar>({
    queryClient,
    queryKey: [queryKey, externalConnectionId],
    fetch: () => getExternalConnectionCalendars(externalConnectionId),
    source: 'external-connections-get-calendars',
  });

export const useExternalConnectionCalendarsQuery = (
  externalConnectionId: ID,
) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: [queryKey, externalConnectionId],
    queryFn: createExternalConnectionCalendarsQueryFn(
      queryClient,
      externalConnectionId,
    ),
    staleTime: 5 * 60 * 1000,
  });
};
